import script from "./ConfirmAuthorDuplicateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmAuthorDuplicateModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmAuthorDuplicateModal.vue?vue&type=style&index=0&id=486874bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-486874bc"]])

export default __exports__